var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#F4F2FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 14.25H15.75C15.3522 14.25 14.9706 14.4081 14.6893 14.6894C14.408 14.9707 14.25 15.3522 14.25 15.75V18.75C14.25 19.1479 14.408 19.5294 14.6893 19.8107C14.9706 20.092 15.3522 20.25 15.75 20.25H18.75C19.1478 20.25 19.5294 20.092 19.8107 19.8107C20.092 19.5294 20.25 19.1479 20.25 18.75V15.75C20.25 15.3522 20.092 14.9707 19.8107 14.6894C19.5294 14.4081 19.1478 14.25 18.75 14.25ZM18.75 21.75H15.75C15.3522 21.75 14.9706 21.9081 14.6893 22.1894C14.408 22.4707 14.25 22.8522 14.25 23.25V26.25C14.25 26.6479 14.408 27.0294 14.6893 27.3107C14.9706 27.592 15.3522 27.75 15.75 27.75H18.75C19.1478 27.75 19.5294 27.592 19.8107 27.3107C20.092 27.0294 20.25 26.6479 20.25 26.25V23.25C20.25 22.8522 20.092 22.4707 19.8107 22.1894C19.5294 21.9081 19.1478 21.75 18.75 21.75ZM27.87 16.1925L25.8075 14.13C25.5265 13.8507 25.1463 13.6938 24.75 13.6938C24.3537 13.6938 23.9735 13.8507 23.6925 14.13L21.63 16.1925C21.3506 16.4736 21.1938 16.8538 21.1938 17.25C21.1938 17.6463 21.3506 18.0265 21.63 18.3075L23.6925 20.37C23.9735 20.6494 24.3537 20.8062 24.75 20.8062C25.1463 20.8062 25.5265 20.6494 25.8075 20.37L27.87 18.3075C28.1494 18.0265 28.3062 17.6463 28.3062 17.25C28.3062 16.8538 28.1494 16.4736 27.87 16.1925ZM26.25 21.75H23.25C22.8522 21.75 22.4706 21.9081 22.1893 22.1894C21.908 22.4707 21.75 22.8522 21.75 23.25V26.25C21.75 26.6479 21.908 27.0294 22.1893 27.3107C22.4706 27.592 22.8522 27.75 23.25 27.75H26.25C26.6478 27.75 27.0294 27.592 27.3107 27.3107C27.592 27.0294 27.75 26.6479 27.75 26.25V23.25C27.75 22.8522 27.592 22.4707 27.3107 22.1894C27.0294 21.9081 26.6478 21.75 26.25 21.75Z",
    fill: "#7529D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.18b47ce9b1e9957229219cc7ffc13f28.svg";
export { ForwardRef as ReactComponent };